export default __webpack_public_path__ + "static/media/V4.e5d9d432.mp4";